import store from "@/store/store";

export default async (to, from, next) => {
  if (!store.state.order.order.completedOrderId) {
    return next();
  }

  return next("/");
};
